import { render, staticRenderFns } from "./AdminSuperMemberCenterSettings.vue?vue&type=template&id=5073e41c&scoped=true&lang=pug&"
import script from "./AdminSuperMemberCenterSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSuperMemberCenterSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperMemberCenterSettings.vue?vue&type=style&index=0&id=5073e41c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073e41c",
  null
  
)

export default component.exports